<template>
  <FormTemplate>
    <template v-slot:form-body>
      <v-form ref="formSocialMedias" @submit.prevent="saveForm">
        <v-row>
          <v-col cols="12" md="3">
            <label for="icon">Icono</label>
          </v-col>

          <v-col cols="12" md="9" class="pb-0">
            <v-file-input
              id="icon"
              v-model="image"
              outlined
              prepend-icon=""
              dense
              placeholder="Elige una imagen"
              @change="onFileChange"
            ></v-file-input>
          </v-col>

          <v-col v-if="url || socialMediasEdited" cols="12" class="pb-0">
            <div class="section">
              <img draggable="false" :src="url || loadImage(socialMedias.icon)" :alt="socialMedias.description" />
            </div>
          </v-col>

          <v-col cols="12" md="3">
            <label for="description">Nombre de la red social</label>
          </v-col>

          <v-col cols="12" md="9" class="pb-0">
            <v-text-field
              id="description"
              v-model="socialMedias.description"
              outlined
              dense
              placeholder="Facebook"
              :rules="required"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <label for="url_social_medias">URL de la red social</label>
          </v-col>

          <v-col cols="12" md="9" class="pb-0">
            <v-text-field
              id="url_social_medias"
              v-model="socialMedias.url_social_medias"
              outlined
              dense
              placeholder="Linkedin del Funcionario"
              :rules="isURL"
            ></v-text-field>
          </v-col>

          <v-col offset-md="3" cols="9">
            <v-btn type="submit" :disabled="loading" :loading="loading" color="primary"> Guardar </v-btn>
            <v-btn type="reset" @click="reset" class="mx-2" outlined> Limpiar </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </FormTemplate>
</template>

<script>
import FormTemplate from '@/components/forms/FormTemplate.vue'
import { loadAPIImage } from '@/utils/images'

export default {
  components: {
    FormTemplate,
  },
  props: {
    socialMediasEdited: Object,
    loading: Boolean,
  },
  data() {
    return {
      required: [v => !!v || 'Requerido'],
      isEmail: [v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Correo electrónico inválido'],
      isURL: [
        v =>
          !v ||
          /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(
            v,
          ) ||
          'El URL debe tener https:// o http://',
      ],
      url: '',
      image: null,
      socialMedias: this.socialMediasEdited ? { ...this.socialMediasEdited } : {},
    }
  },
  methods: {
    validateForm() {
      return this.$refs.formSocialMedias.validate()
    },
    reset() {
      this.$refs.formSocialMedias.resetValidation()
    },
    saveForm() {
      if (!this.validateForm()) return
      if (this.socialMediasEdited) {
        let DTO = { ...this.socialMedias }

        if (this.image) {
          DTO = {
            ...DTO,
            file: this.image,
          }
        }
        this.$emit('beforeUpdate', DTO)
      } else {
        const DTO = { ...this.socialMedias, file: this.image }
        this.$emit('beforeCreate', DTO)
      }
    },
    loadImage(src) {
      return loadAPIImage(src)
    },
    onFileChange(e) {
      if (!e) return
      this.url = URL.createObjectURL(e)
      // // console.log(this.url);
    },
  },
}
</script>

<style lang="scss" scoped>
.img-officer {
  padding: 10px;
}

.img-officer img {
  max-width: 200px;
  max-height: 200px;
}

.center-sub-items {
  display: flex;
  justify-content: center;
  align-items: center;
}

.section {
  display: flex;
  justify-content: center;
  align-items: center;
}
.section img {
  max-width: 150px;
  max-height: 150px;
}
</style>
